const BlogPage = () =>
  import(/* webpackChunkName: "blog-page" */ '@/pages/blog/blog/page/index.vue')

const CreateBlogPage = () =>
  import(
    /* webpackChunkName: "blog-page" */ '@/pages/blog/blog/page/create.vue'
  )
const EditBlogPage = () =>
  import(/* webpackChunkName: "blog-page" */ '@/pages/blog/blog/page/edit.vue')

export default {
  path: 'page',
  meta: {
    label: 'page',
    auth: 'page'
  },
  component: {
    name: 'Page',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BlogPageReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: BlogPage
    },
    {
      name: 'BlogCreatePage',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateBlogPage
    },
    {
      name: 'BlogEditPage',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditBlogPage,
      props: true
    }
  ]
}
